/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { SupplierStoreOrderVariance } from './SupplierStoreOrderVariance';
// @ts-ignore
import {
// @ts-ignore
    SupplierStoreOrderVarianceFromJSON,
// @ts-ignore
    SupplierStoreOrderVarianceFromJSONTyped,
// @ts-ignore
    SupplierStoreOrderVarianceToJSON,
} from './SupplierStoreOrderVariance';

/**
 * 
 * @export
 * @interface SupplierStoreOrderVarianceListResponse
 */
export interface SupplierStoreOrderVarianceListResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplierStoreOrderVarianceListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplierStoreOrderVarianceListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<SupplierStoreOrderVariance>}
     * @memberof SupplierStoreOrderVarianceListResponse
     */
    items: Array<SupplierStoreOrderVariance>;
}

/**
 * Check if a given object implements the SupplierStoreOrderVarianceListResponse interface.
 */
// @ts-ignore
export function instanceOfSupplierStoreOrderVarianceListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function SupplierStoreOrderVarianceListResponseFromJSON(json: any): SupplierStoreOrderVarianceListResponse {
    return SupplierStoreOrderVarianceListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function SupplierStoreOrderVarianceListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierStoreOrderVarianceListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(SupplierStoreOrderVarianceFromJSON)),
    };
}

// @ts-ignore
export function SupplierStoreOrderVarianceListResponseToJSON(value?: SupplierStoreOrderVarianceListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(SupplierStoreOrderVarianceToJSON)),
    };
}

